import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { AgentgroupForm } from '../../agents/model/agent.model';
import { AgentService } from '../../agents/agent.service';


@Component({
  selector: 'app-agent-group',
  templateUrl: './agent-group.component.html',
  styleUrls: ['./agent-group.component.css']
})
export class AgentGroupComponent implements OnInit {
  contactForm: FormGroup
  submitted: boolean = false;
  cdata: any;
  didgroup: any = [];
  dropdownList = [];
  calValue = []

  DIDgroup_id: number;
  emailgroup_id: number
  calgroup_id: number
  public dispogroup: any = [];
  messageList: any = [];
  get f() { return this.contactForm.controls; }
  constructor(@Inject(MAT_DIALOG_DATA) public data: any, public dialogRef: MatDialogRef<AgentGroupComponent>, protected fb: FormBuilder, public data4: AgentService) {
    console.log(this.data);
    if (this.data) {
      this.cdata = new AgentgroupForm(this.data);
      this.contactForm = this.cdata.makeform(this.fb);
      this.contactForm.get('group_name').disable();
      this.DIDgroup_id = this.data.didgroupid

    }
    else {
      this.cdata = new AgentgroupForm(null);
      this.contactForm = this.cdata.makeform(this.fb);
      this.DIDgroup_id = 0;
      this.emailgroup_id = 0
      this.calgroup_id = 0
    }


  }

  ngOnInit() {
    this.emailGroup(this.emailgroup_id)
    this.calendarGroup(this.calgroup_id)
    this.didgroups(this.DIDgroup_id);
    this.dispositiongroup();
    this.loadMessages();
  }
  onSubmitgroup() {
    console.log("form value",this.contactForm.value);

    this.submitted = true
    if (this.contactForm.invalid) {
      return false
    }

    this.dialogRef.close(this.contactForm.value);
  }
  close() {
    this.dialogRef.close();
  }
  didgroups(groupid: number) {
    this.data4.getdidgroups(groupid).subscribe((res: any) => {
      this.didgroup = res.records;
    })
  }
  onAutoScriptChange(event: Event): void {
    const checked = (event.target as HTMLInputElement).checked;
    if (checked) {
      console.log('Checkbox is checked (check = 1)');
      // Handle the case when checkbox is checked
    } else {
      console.log('Checkbox is not checked (check = 0)');
      // Handle the case when checkbox is not checked
    }
  }

  emailGroup(idemail: any) {
    this.data4.getEmail(idemail).subscribe(res => {
      console.log("email", res)
      this.dropdownList = res.records
    })
  }

  calendarGroup(calID: any) {
    this.data4.getCaledar(calID).subscribe(res => {
      console.log("calendar", res)
      this.calValue = res.records
    })
  }

  dispositiongroup() {
    this.data4.getService("getdisposdata").subscribe(res=>{
      this.dispogroup = res
    })
  }

  loadMessages() {
    this.data4.getMessages().subscribe((res: any) => {
      this.messageList = res || [];
    });
  }
}
